import { useTranslation } from "react-i18next";
import Html5QrcodePlugin from "./Html5QrcodePlugin";
import Modal from "./Modal";

interface BarcodeScannerModal {
    open: boolean;
    onClose: () => void;
    onRead: (code: string) => void;
}

const BarcodeScannerModal = (props: BarcodeScannerModal) => {
    const { t } = useTranslation("translations");
    const {
        open,
        onClose
    } = props;

    const onNewScanResult = (decodedText: any, decodedResult: any) => {
        props.onRead(decodedText);
        onClose();
    };
    
    return (
        <Modal
            header={t("BARCODE_SCANER_READ")}
            isOpen={open}
            onClose={onClose}
        >
            <div className="h-fit">
                <Html5QrcodePlugin
                    fps={5}
                    qrbox={250}
                    disableFlip={false}
                    verbose={true}
                    qrCodeSuccessCallback={onNewScanResult}
                    qrCodeErrorCallback={(e) => {}}
                />
            </div>
        </Modal>
    )
};

export default BarcodeScannerModal;